import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../config/api';
import DOMPurify from 'isomorphic-dompurify';
import './ChurchPage.css';

function ChurchNewsDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    fetchPost();
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const fetchPost = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/post?id=${id}`);
      const data = await response.json();

      if (data.success) {
        setPost(data.data);
      } else {
        alert('게시글을 찾을 수 없습니다.');
        navigate('/church/news');
      }
    } catch (error) {
      console.error('Error fetching post:', error);
      alert('게시글을 불러오는데 실패했습니다.');
      navigate('/church/news');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    const hour = dateString.substring(8, 10);
    const minute = dateString.substring(10, 12);
    return `${year}.${month}.${day} ${hour}:${minute}`;
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    window.location.href = '/church';
  };

  const handleDelete = async () => {
    if (!window.confirm('정말 삭제하시겠습니까?')) return;

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/post/delete?id=${post.document_srl}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      if (data.success) {
        alert('삭제되었습니다.');
        navigate('/church/news');
      } else {
        alert(data.error || '삭제 실패');
      }
    } catch (e) {
      console.error(e);
      alert('삭제 중 오류 발생');
    }
  };

  const canEdit = user && post && (String(user.member_srl) === String(post.member_srl) || user.is_admin === 'Y' || user.nick_name === '정용섭');

  return (
    <div className="church-wrap">
      <header className="church-header">
        <div className="header-inner">
          <div className="user-menu">
            {user ? (
              <>
                <span className="user-name">{user.nick_name}님</span>
                <button onClick={handleLogout} className="auth-link">로그아웃</button>
              </>
            ) : (
              <>
                <Link to="/login" className="auth-link">로그인</Link>
                <Link to="/signup" className="auth-link">회원가입</Link>
              </>
            )}
          </div>
          <div className="logo-top">
            <Link to="/church" className="logo-main">
              <img src="/images/church-logo.png" alt="다비아샘터교회" />
            </Link>
          </div>
          <div className="nav-row">
            <Link to="/" className="logo-sub" title="다비아 메인으로 이동">
              <img src="/images/dasaem-logo.jpg" alt="대구성서아카데미" />
            </Link>
            <nav>
              <Link to="/">다비아 홈</Link>
              <Link to="/church">교회소개</Link>
              <Link to="/church/news">교회소식</Link>
              <Link to="/church/committee">운영위원회</Link>
            </nav>
          </div>
        </div>
      </header>

      <main className="church-main">
        <div className="content-wrap">
          {loading ? (
            <div className="loading-state">로딩 중...</div>
          ) : post ? (
            <article className="post-detail">
              <div className="post-header">
                <h1>{post.title}</h1>
                <div className="post-meta">
                  <span className="author">{post.nick_name}</span>
                  <span className="separator">|</span>
                  <span className="date">{formatDate(post.regdate)}</span>
                  <span className="separator">|</span>
                  <span className="views">조회 {post.readed_count}</span>
                </div>
              </div>

              <div className="post-content" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post.content) }} />

              <div className="post-actions" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Link to="/church/news" className="btn-list">목록으로</Link>
                {canEdit && (
                  <div className="btn-group">
                    {/* 수정 기능은 WritePage에서 id 파라미터를 받아 처리하도록 추후 구현 필요 */}
                    {/* <Link to={`/write/churchs?id=${post.document_srl}`} className="btn-edit" style={{ marginRight: '10px' }}>수정</Link> */}
                    <button onClick={handleDelete} className="btn-delete" style={{
                      padding: '8px 16px',
                      backgroundColor: '#d32f2f',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer'
                    }}>삭제</button>
                  </div>
                )}
              </div>
            </article>
          ) : (
            <div className="empty-state">게시글을 찾을 수 없습니다.</div>
          )}
        </div>
      </main>

      <footer className="church-footer">
        <div className="footer-links">
          <a href="http://dabia.net" target="_blank" rel="noopener noreferrer">대구성서아카데미</a>
          <a href="/seoul-church">서울샘터교회</a>
          <a href="https://indiadabia.blogspot.com/" target="_blank" rel="noopener noreferrer">설교링크</a>
        </div>
        <button className="scroll-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          ↑
        </button>
      </footer>
    </div>
  );
}

export default ChurchNewsDetailPage;
